<template>
  <div class="p-3 text-left">
    <h3>{{ $t('general.general_config') }}</h3>
    <hr />
    <div class="container">
      <el-card>
        <div>
          <div
            v-for="config in configs"
            :key="config.id"
            class="d-flex justify-content-between align-items-center my-3"
          >
            <div class="mr-3 w-25">
              {{ $t(config.get('translationKey')) }}
            </div>
            <el-input class="mr-3" disabled :value="config.get('value')" />
            <el-link type="primary" @click="onConfigSelected(config)">
              {{ $t('general.edit') }}
            </el-link>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../../event-bus.js';
import ConfigEditModal from '../../../components/modals/ConfigEditModal';
export default {
  name: 'AdminGeneralConfigView',
  components: {},
  props: {},
  async mounted() {
    await this.loadConfigs();
    EventBus.$on('AdminConfigUpdated', this.loadConfigs);
  },
  destroyed() {
    EventBus.$off('AdminConfigUpdated');
  },
  data() {
    return {
      configs: [],
    };
  },
  computed: {},
  methods: {
    async loadConfigs() {
      let query = new this.$parse.Query('Config');
      this.configs = await query.find();
    },
    onConfigSelected(config) {
      this.$modal.show(ConfigEditModal, { config: config }, { height: 'auto', width: '500px' });
    },
  },
};
</script>

<style scoped></style>
